import { aqua, gray2 } from 'assets/stylesheets/base/_colors';
import { COMPASS_BACKEND_FORMAT } from 'constants/date/dateFormats.constant';
import DateStringTransform from 'utility/date/dateString.utility';

export default class PlotLineGenerator {
  _plannedLSIplotLineConfig = {
    color: gray2,
    dashStyle: 'LongDash',
  };

  _forecastLSIplotLineConfig = {
    color: aqua,
    dashStyle: 'LongDash',
  };

  _getPlannedLSIPlotLine(position) {
    let formattedDateString = new DateStringTransform(position).formatter(
      COMPASS_BACKEND_FORMAT,
    );

    if (formattedDateString) {
      formattedDateString = formattedDateString.replace(/-\d{2}$/, '-03');
    }
    return {
      value: new Date(formattedDateString),
      zIndex: 3,
      ...this._plannedLSIplotLineConfig,
    };
  }

  _getForecastLSIPlotLine(position) {
    const formattedDateString = new DateStringTransform(position).formatter(
      COMPASS_BACKEND_FORMAT,
    );

    return {
      value: new Date(formattedDateString),
      zIndex: 3,
      ...this._forecastLSIplotLineConfig,
    };
  }
}
